import { createFileRoute } from '@tanstack/react-router';
import SignInForm from './-components/sign-in-form';
import { AuthLayout } from '~/components/auth-layout';
import { DocumentRedirect } from '~/components/document-redirect';
import { isSignedIn } from '~/lib/auth-client';
import { DEFAULT_AUTH_REDIRECT, validateAuthSearch } from '~/lib/auth-redirect';

export const Route = createFileRoute('/sign-in')({
  validateSearch: validateAuthSearch,
  beforeLoad: async () => ({ signedIn: await isSignedIn() }),
  component: SignInPage,
});

function SignInPage() {
  const { redirect } = Route.useSearch();
  const { signedIn } = Route.useRouteContext();

  if (signedIn) {
    return <DocumentRedirect to={redirect ?? DEFAULT_AUTH_REDIRECT} />;
  }

  return (
    <AuthLayout>
      <SignInForm />
    </AuthLayout>
  );
}
